import React from 'react';
import {
    Document,
    Page,
    Text,
    View,
    Image,
    StyleSheet,
    PDFViewer,
    PDFDownloadLink
} from '@react-pdf/renderer';
import { Clock, Download } from 'lucide-react';

// ⬅ Ajuste ce chemin selon l'emplacement réel du logo dans ton projet
//import logoSoplast from '../../logo-soplast.png';
import logoSoplast from '../../logoSoplast';


// Informations légales de l'émetteur (extraites du modèle client)
const COMPANY = {
    name: 'SENEGAL SOPLAST',
    addressLine: 'Point E, Rue G X, Rue de Kolda',
    city: 'Dakar-Senegal',
    phone: '+221 33 805 47 50 / 78 911 95 27',
    ninea: '012093530',
    rc: 'SN DKR 2025 B 16191',
    bank: 'Banque BNDE: SN169 00106309301 54',
};



// Format de date jj/mm/aaaa (comme le modèle)
const formatDate = (dateString) => {
    if (!dateString) return '';
    const d = new Date(dateString);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
};

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Helvetica',
        fontSize: 9,
        paddingTop: 30,
        paddingLeft: 35,
        paddingRight: 35,
        paddingBottom: 40,
        backgroundColor: '#ffffff',
        color: '#000000',
    },

    // ===== En-tête =====
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        paddingBottom: 10,
        borderBottomWidth: 1.5,
        borderBottomColor: '#000000',
        borderBottomStyle: 'solid',
    },
    headerLeft: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    logo: {
        width: 60,
        height: 38,
        marginRight: 8,
    },
    companyName: {
        fontSize: 16,
        fontFamily: 'Helvetica-Bold',
        color: '#000000',
        lineHeight: 1.05,
    },
    headerRight: {
        textAlign: 'left',
    },
    headerInfo: {
        fontSize: 8.5,
        color: '#000000',
        marginBottom: 1.5,
    },

    // ===== Bloc client / titre =====
    midSection: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: 14,
        marginBottom: 10,
    },
    clientBlock: {
        width: '55%',
    },
    clientLabel: {
        fontSize: 10,
        fontFamily: 'Helvetica-Bold',
        marginBottom: 4,
    },
    clientName: {
        fontSize: 10,
        fontFamily: 'Helvetica-Bold',
        marginBottom: 2,
    },
    clientLine: {
        fontSize: 9,
        marginBottom: 1,
    },
    orderNumberLine: {
        marginTop:2,
        fontSize: 11,
        fontFamily: 'Helvetica-Bold',
        marginBottom: 1,
    },
    titleBlock: {
        width: '40%',
        alignItems: 'flex-end',
    },
    docTitle: {
        fontSize: 18,
        fontFamily: 'Helvetica-Bold',
        marginBottom: 6,
    },
    docMetaRow: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
    },
    docMetaLabel: {
        fontSize: 9,
        fontFamily: 'Helvetica-Bold',
        marginRight: 8,
    },
    docMetaValue: {
        fontSize: 9,
        minWidth: 60,
        textAlign: 'left',
    },

    invoiceRef: {
        textAlign: 'center',
        fontSize: 11,
        fontFamily: 'Helvetica-Bold',
        marginTop: 4,
        marginBottom: 8,
    },

    // ===== Tableau produits =====
    table: {
        borderWidth: 1,
        borderColor: '#000000',
        borderStyle: 'solid',
        marginBottom: 22,
    },
    tableRow: {
        flexDirection: 'row',
        borderBottomWidth: 0.5,
        borderBottomColor: '#666666',
        borderBottomStyle: 'solid',
        alignItems: 'stretch',
        minHeight: 22,
    },
    tableHeaderRow: {
        backgroundColor: '#dce6f1',
        borderBottomWidth: 1,
        borderBottomColor: '#000000',
    },
    totalRow: {
        borderTopWidth: 1,
        borderTopColor: '#000000',
        borderBottomWidth: 0,
        minHeight: 24,
    },
    // Cellules (avec bordure verticale)
    cell: {
        paddingVertical: 4,
        paddingHorizontal: 4,
        borderRightWidth: 0.5,
        borderRightColor: '#666666',
        borderRightStyle: 'solid',
        justifyContent: 'center',
    },
    cellLast: {
        borderRightWidth: 0,
    },
    headerCellText: {
        fontSize: 8.5,
        fontFamily: 'Helvetica-Bold',
        textAlign: 'center',
    },
    cellText: {
        fontSize: 8.5,
        textAlign: 'left',
    },
    cellTextCenter: {
        fontSize: 8.5,
        textAlign: 'center',
    },
    totalText: {
        fontSize: 9,
        fontFamily: 'Helvetica-Bold',
        textAlign: 'center',
    },
    // Largeurs colonnes (somme = 100%)
    colRef: { width: '10%' },
    colEan: { width: '20%' },
    colLib: { width: '34%' },
    colQteCmd: { width: '12%' },
    colQteLiv: { width: '12%' },
    colQteRest: { width: '12%' },

    // ===== Pied de page : visas =====
    visaTable: {
        borderWidth: 1,
        borderColor: '#000000',
        borderStyle: 'solid',
    },
    visaHeaderRow: {
        flexDirection: 'row',
        backgroundColor: '#dce6f1',
        borderBottomWidth: 1,
        borderBottomColor: '#000000',
    },
    visaRow: {
        flexDirection: 'row',
        borderBottomWidth: 0.5,
        borderBottomColor: '#666666',
        minHeight: 38,
    },
    visaRowLast: {
        borderBottomWidth: 0,
    },
    visaCell: {
        width: '50%',
        padding: 6,
        borderRightWidth: 0.5,
        borderRightColor: '#666666',
    },
    visaCellLast: {
        borderRightWidth: 0,
    },
    visaHeaderText: {
        fontSize: 9.5,
        fontFamily: 'Helvetica-Bold',
        textAlign: 'center',
        padding: 5,
    },
    visaLabel: {
        fontSize: 9,
        fontFamily: 'Helvetica-Bold',
    },

    notes: {
        marginTop: 12,
    },
    notesTitle: {
        fontSize: 9,
        fontFamily: 'Helvetica-Bold',
        marginBottom: 3,
    },
    notesText: {
        fontSize: 9,
    },
});

// Composant contenu du PDF
const DeliveryNotePDF = ({ deliveryNote }) => {
    const items = Array.isArray(deliveryNote.items) ? deliveryNote.items : [];

    // Numéro de facture liée — non câblé pour l'instant => placeholder ####
    const invoiceNumber = deliveryNote.invoiceNumber || '####';

    // Totaux
    const totalCmd = items.reduce((acc, it) => acc + (Number(it.quantity) || 0), 0);
    const totalLiv = items.reduce((acc, it) => acc + (Number(it.deliveredQuantity) || 0), 0);
    const totalRest = totalCmd - totalLiv;

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                {/* En-tête : logo + bloc légal */}
                <View style={styles.header}>
                    <View style={styles.headerLeft}>
                        <Image src={logoSoplast} style={styles.logo} />
                        <Text style={styles.companyName}>SENEGAL{'\n'}SOPLAST</Text>
                    </View>
                    <View style={styles.headerRight}>
                        <Text style={styles.headerInfo}>{COMPANY.addressLine}</Text>
                        <Text style={styles.headerInfo}>{COMPANY.city}</Text>
                        <Text style={styles.headerInfo}>Téléphone: {COMPANY.phone}</Text>
                        <Text style={styles.headerInfo}>NINEA: {COMPANY.ninea}</Text>
                        <Text style={styles.headerInfo}>RC: {COMPANY.rc}</Text>
                        <Text style={styles.headerInfo}>{COMPANY.bank}</Text>
                    </View>
                </View>

                {/* Bloc client (gauche) + titre document (droite) */}
                <View style={styles.midSection}>
                    <View style={styles.clientBlock}>
                        <Text style={styles.clientLabel}>CLIENT</Text>
                        <Text style={styles.clientName}>{deliveryNote.clientName}</Text>
                        {deliveryNote.clientAddress && (
                            <Text style={styles.clientLine}>Adresse: {deliveryNote.clientAddress}</Text>
                        )}
                        {deliveryNote.clientPhone && (
                            <Text style={styles.clientLine}>Tél: {deliveryNote.clientPhone}</Text>
                        )}
                        {deliveryNote.orderNumber && (
                            <Text style={styles.orderNumberLine}>N° de commande: {deliveryNote.orderNumber}</Text>
                        )}
                    </View>

                    <View style={styles.titleBlock}>
                        <Text style={styles.docTitle}>BON DE LIVRAISON</Text>
                        <View style={styles.docMetaRow}>
                            <Text style={styles.docMetaLabel}>N°:</Text>
                            <Text style={styles.docMetaValue}>{deliveryNote.referenceNumber}</Text>
                        </View>
                        <View style={styles.docMetaRow}>
                            <Text style={styles.docMetaLabel}>Date:</Text>
                            <Text style={styles.docMetaValue}>{formatDate(deliveryNote.createdAt)}</Text>
                        </View>
                    </View>
                </View>

                {/* Référence facture */}
                <Text style={styles.invoiceRef}>FACTURE N° {invoiceNumber}</Text>

                {/* Tableau produits */}
                <View style={styles.table}>
                    {/* En-tête */}
                    <View style={[styles.tableRow, styles.tableHeaderRow]}>
                        <View style={[styles.cell, styles.colRef]}>
                            <Text style={styles.headerCellText}>Ref</Text>
                        </View>
                        <View style={[styles.cell, styles.colEan]}>
                            <Text style={styles.headerCellText}>EAN principal</Text>
                        </View>
                        <View style={[styles.cell, styles.colLib]}>
                            <Text style={styles.headerCellText}>Libellé</Text>
                        </View>
                        <View style={[styles.cell, styles.colQteCmd]}>
                            <Text style={styles.headerCellText}>Qté Commandée</Text>
                        </View>
                        <View style={[styles.cell, styles.colQteLiv]}>
                            <Text style={styles.headerCellText}>Qté Livrée</Text>
                        </View>
                        <View style={[styles.cell, styles.cellLast, styles.colQteRest]}>
                            <Text style={styles.headerCellText}>Qté restante à livrer</Text>
                        </View>
                    </View>

                    {/* Lignes */}
                    {items.length > 0 ? (
                        items.map((item, index) => {
                            const cmd = Number(item.quantity) || 0;
                            const liv = Number(item.deliveredQuantity) || 0;
                            const rest = cmd - liv;
                            return (
                                <View key={index} style={styles.tableRow}>
                                    <View style={[styles.cell, styles.colRef]}>
                                        <Text style={styles.cellTextCenter}>{item.numeroProduit}</Text>
                                    </View>
                                    <View style={[styles.cell, styles.colEan]}>
                                        <Text style={styles.cellTextCenter}>{item.codeBarre}</Text>
                                    </View>
                                    <View style={[styles.cell, styles.colLib]}>
                                        <Text style={styles.cellText}>{item.productName+'-'+item.productCode}</Text>
                                    </View>
                                    <View style={[styles.cell, styles.colQteCmd]}>
                                        <Text style={styles.cellTextCenter}>{cmd}</Text>
                                    </View>
                                    <View style={[styles.cell, styles.colQteLiv]}>
                                        <Text style={styles.cellTextCenter}>{liv}</Text>
                                    </View>
                                    <View style={[styles.cell, styles.cellLast, styles.colQteRest]}>
                                        <Text style={styles.cellTextCenter}>{rest}</Text>
                                    </View>
                                </View>
                            );
                        })
                    ) : (
                        <View style={styles.tableRow}>
                            <View style={{ width: '100%', padding: 6 }}>
                                <Text style={styles.cellText}>Aucun produit dans ce bon de livraison</Text>
                            </View>
                        </View>
                    )}

                    {/* Ligne TOTAL */}
                    <View style={[styles.tableRow, styles.totalRow]}>
                        <View style={[styles.cell, styles.colRef]}>
                            <Text style={styles.totalText}>TOTAL</Text>
                        </View>
                        <View style={[styles.cell, styles.colEan]}>
                            <Text style={styles.totalText}> </Text>
                        </View>
                        <View style={[styles.cell, styles.colLib]}>
                            <Text style={styles.totalText}> </Text>
                        </View>
                        <View style={[styles.cell, styles.colQteCmd]}>
                            <Text style={styles.totalText}>{totalCmd}</Text>
                        </View>
                        <View style={[styles.cell, styles.colQteLiv]}>
                            <Text style={styles.totalText}>{totalLiv}</Text>
                        </View>
                        <View style={[styles.cell, styles.cellLast, styles.colQteRest]}>
                            <Text style={styles.totalText}>{totalRest}</Text>
                        </View>
                    </View>
                </View>

                {/* Pied de page : visas */}
                <View style={styles.visaTable}>
                    <View style={styles.visaHeaderRow}>
                        <View style={[styles.visaCell]}>
                            <Text style={styles.visaHeaderText}>Visa du client et observations éventuelles</Text>
                        </View>
                        <View style={[styles.visaCell, styles.visaCellLast]}>
                            <Text style={styles.visaHeaderText}>Visa du fournisseur</Text>
                        </View>
                    </View>

                    <View style={styles.visaRow}>
                        <View style={styles.visaCell}>
                            <Text style={styles.visaLabel}>Reçu le:</Text>
                        </View>
                        <View style={[styles.visaCell, styles.visaCellLast]}>
                            <Text style={styles.visaLabel}>Solde (montant et date):</Text>
                        </View>
                    </View>

                    <View style={styles.visaRow}>
                        <View style={styles.visaCell}>
                            <Text style={styles.visaLabel}>Réserve sur la livraison:</Text>
                        </View>
                        <View style={[styles.visaCell, styles.visaCellLast]}>
                            <Text style={styles.visaLabel}>Livré le: {formatDate(deliveryNote.deliveryDate)}</Text>
                        </View>
                    </View>

                    <View style={[styles.visaRow, styles.visaRowLast]}>
                        <View style={styles.visaCell}>
                            <Text style={styles.visaLabel}>Signature:</Text>
                        </View>
                        <View style={[styles.visaCell, styles.visaCellLast]}>
                            <Text style={styles.visaLabel}>Signature:</Text>
                        </View>
                    </View>
                </View>

                {/* Notes générales si présentes */}
                {deliveryNote.notes && (
                    <View style={styles.notes}>
                        <Text style={styles.notesTitle}>Notes et observations:</Text>
                        <Text style={styles.notesText}>{deliveryNote.notes}</Text>
                    </View>
                )}
            </Page>
        </Document>
    );
};

// Aperçu
const DeliveryNotePDFViewer = ({ deliveryNote, company }) => (
    <PDFViewer width="100%" height={600} style={{ border: 'none' }}>
        <DeliveryNotePDF deliveryNote={deliveryNote} company={company} />
    </PDFViewer>
);

// Lien de téléchargement
const DeliveryNotePDFDownloadLink = ({ deliveryNote, company }) => (
    <PDFDownloadLink
        document={<DeliveryNotePDF deliveryNote={deliveryNote} company={company} />}
        fileName={`bon_livraison_${deliveryNote.referenceNumber}.pdf`}
        style={{
            textDecoration: 'none',
            padding: '0.25rem 0.5rem',
            backgroundColor: 'transparent',
            color: '#0dcaf0',
            border: '1px solid #0dcaf0',
            borderRadius: '0.375rem',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.875rem',
            lineHeight: '1.5',
            minHeight: '31px',
        }}
        className="me-1"
    >
        {({ blob, url, loading, error }) =>
            loading ? <Clock size={16} /> : <Download size={16} />
        }
    </PDFDownloadLink>
);

// Composant principal
const GenererPdfBonLivraison = ({ deliveryNote, company, showPreview = false, onDownload = null }) => {
    if (onDownload) {
        return (
            <PDFDownloadLink
                document={<DeliveryNotePDF deliveryNote={deliveryNote} company={company} />}
                fileName={`bon_livraison_${deliveryNote.referenceNumber}.pdf`}
                style={{ display: 'none' }}
            >
                {({ blob, url, loading, error }) => {
                    if (!loading && !error && blob) {
                        onDownload(blob);
                    } else if (error) {
                        console.error("Erreur lors de la génération du PDF:", error);
                    }
                    return null;
                }}
            </PDFDownloadLink>
        );
    }

    return (
        <div>
            {showPreview ? (
                <DeliveryNotePDFViewer deliveryNote={deliveryNote} company={company} />
            ) : (
                <DeliveryNotePDFDownloadLink deliveryNote={deliveryNote} company={company} />
            )}
        </div>
    );
};

export default GenererPdfBonLivraison;